import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';
import { CommunicationsResponse } from './communications.model';

interface CommunicationsState {
  payloadByTeamId: Record<number, CommunicationsResponse | null>;
  activeTeamId: number | null;
}

const initialState: CommunicationsState = {
  payloadByTeamId: {},
  activeTeamId: null
};

export const communicationsSlice = createSlice({
  name: 'communications',
  initialState,
  reducers: {
    setCommunicationsActiveTeamId: (state, { payload }: PayloadAction<number | null>) => {
      state.activeTeamId = payload;
    },
    setCommunicationsPayload: (state, { payload }: PayloadAction<{ teamId: number; data: CommunicationsResponse }>) => {
      // activeTeamId is owned by team selection only. Updating it here lets a
      // late response from a previous team steal the active communications view.
      state.payloadByTeamId[payload.teamId] = payload.data;
    },
    clearCommunicationsPayloadForTeam: (state, { payload }: PayloadAction<number>) => {
      delete state.payloadByTeamId[payload];
      if (state.activeTeamId === payload) {
        state.activeTeamId = null;
      }
    }
  }
});

export const { setCommunicationsActiveTeamId, setCommunicationsPayload, clearCommunicationsPayloadForTeam } =
  communicationsSlice.actions;

export const selectCommunicationsPayload = (state: RootState): CommunicationsResponse | null => {
  const { activeTeamId, payloadByTeamId } = state.rootReducer.communications;
  if (activeTeamId == null) return null;
  return payloadByTeamId[activeTeamId] ?? null;
};

export const selectCommunicationsPayloadForTeam = (teamId: number | null | undefined) => (state: RootState) => {
  if (teamId == null) return null;
  return state.rootReducer.communications.payloadByTeamId[teamId] ?? null;
};

export default communicationsSlice.reducer;
